import { useEffect, useRef } from "react";
import { CSSTransition } from "react-transition-group";
import { useHudOverlay } from "widgets/hud/model/overlayStore";
import { AnimatedWrap, LogoRow, Overlay } from "./styles";
import { useOutClick } from "app/lib/hooks/useOutClick";
import { Logo } from "shared/ui/icons/logo.tsx";
import { DesktopHudLogo, DesktopHudTitle } from "widgets/hud/ui/styles.ts";
import { CloseIcon } from "shared/ui/icons/closeIcon.tsx";
import { MOBILE_MENU_NAV } from "widgets/hud/model/routes.ts";
import { HudButton } from "widgets/hud/ui/HudButton";
import { mergeRefs } from "shared/helpers";
import { createPortal } from "react-dom";

export const MobileMenuModal = () => {
    const openId = useHudOverlay((s) => s.openId);
    const close = useHudOverlay((s) => s.close);

    const containerRef = useRef<HTMLDivElement | null>(null);
    const nodeRef = useRef<HTMLDivElement | null>(null);
    const overlayRef = useRef<HTMLDivElement | null>(null);

    useOutClick(containerRef, close);

    const isOpen = openId === "mobile-menu-modal";

    useEffect(() => {
        if (!isOpen) return;
        const onKey = (e: KeyboardEvent) => {
            if (e.key === "Escape") {
                close();
            }
        };
        document.addEventListener("keydown", onKey);
        const prev = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        return () => {
            document.removeEventListener("keydown", onKey);
            document.body.style.overflow = prev;
        };
    }, [isOpen, close]);

    return createPortal(
        <>
            <CSSTransition
                in={isOpen}
                timeout={200}
                classNames="hud-fade"
                unmountOnExit
                nodeRef={overlayRef}
            >
                <Overlay
                    ref={overlayRef}
                    onClick={close}
                    aria-hidden="true"
                />
            </CSSTransition>

            <CSSTransition
                in={isOpen}
                timeout={{ enter: 200, exit: 150 }}
                classNames="hud-slide"
                unmountOnExit
                nodeRef={nodeRef}
            >
                <AnimatedWrap
                    ref={mergeRefs(containerRef, nodeRef)}
                    role="dialog"
                    aria-modal="true"
                >
                    <LogoRow onClick={() => close()}>
                        <DesktopHudLogo style={{ gap: 8, margin: 0, padding: 0 }} to="/">
                            <Logo />
                            <DesktopHudTitle>Цифровой улей</DesktopHudTitle>
                        </DesktopHudLogo>

                        <CloseIcon />
                    </LogoRow>
                    {MOBILE_MENU_NAV.map((item) => {
                        return (
                            <HudButton
                                style={{ fontSize: 16, gap: 12, padding: 12 }}
                                item={item}
                                key={item.id}
                            />
                        );
                    })}
                </AnimatedWrap>
            </CSSTransition>
        </>,
        document.body
    );
};

export default MobileMenuModal;
